var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3871C9.37645 13.3871 8.87097 13.8926 8.87097 14.5161C8.87097 15.1397 9.37645 15.6452 10 15.6452C10.6235 15.6452 11.129 15.1397 11.129 14.5161C11.129 13.8926 10.6235 13.3871 10 13.3871ZM10.3093 12.4194H9.66411C9.39689 12.4194 9.18024 12.2027 9.18024 11.9355V11.9201C9.18024 9.08371 12.3028 9.35484 12.3028 7.58915C12.3028 6.78206 11.5867 5.96774 9.98669 5.96774C8.81153 5.96774 8.20181 6.35681 7.59915 7.12468C7.44157 7.32548 7.15343 7.36641 6.94399 7.22048L6.41439 6.85153C6.18758 6.69351 6.13778 6.37689 6.30774 6.15891C7.16363 5.06105 8.17911 4.35484 9.98669 4.35484C12.0964 4.35484 13.9157 5.55448 13.9157 7.58915C13.9157 10.3075 10.7931 10.1637 10.7931 11.9201V11.9355C10.7931 12.2027 10.5765 12.4194 10.3093 12.4194ZM10 1.29032C14.7831 1.29032 18.7097 5.16431 18.7097 10C18.7097 14.8101 14.8141 18.7097 10 18.7097C5.19177 18.7097 1.29032 14.816 1.29032 10C1.29032 5.19343 5.18556 1.29032 10 1.29032ZM10 0C4.47754 0 0 4.47915 0 10C0 15.5241 4.47754 20 10 20C15.5225 20 20 15.5241 20 10C20 4.47915 15.5225 0 10 0Z",
    fill: "#668598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.2797c587f7d21e7ffb1fcd73b35d2313.svg";
export { ForwardRef as ReactComponent };